import i18n from '@fiverr/i18n/singleton';
import axios from 'axios';
import type { EagerJobsTbdSdk } from '@fiverr-private/jtbd_sdk';
import { type Store } from '@fiverr-private/store_builder_types';
import { logger } from '@fiverr-private/obs';
import { ROLLOUTS } from '@fiverr-private/homepage_common_types';
import { statsFunctionWrapper } from '@fiverr-private/homepage_utils';
import { storeBuilderIconUrl, storeBuilderUrl } from './StoreBuilderCard.constants';

export const StoreBuilderCardImpl: EagerJobsTbdSdk = {
    condition: {
        rolloutName: ROLLOUTS.HAWKS_AI_STORE_BUILDER_LIHP,
    },

    getJobInfo: async ({ externalServicesInfo, context }) => {
        const { url } = externalServicesInfo.extended_verticals_pegasus;
        const extendedVerticalsPegasusUrl = new URL(url);

        extendedVerticalsPegasusUrl.pathname += '/api/v1/management/bys-stores';

        try {
            const fetcher = () => axios.get<Store>(extendedVerticalsPegasusUrl.toString());
            const response = await statsFunctionWrapper(fetcher, 'jtbd.store_builder.get_bys_stores')();

            if (response.data.status !== 'DRAFT') {
                return { shouldDisplayJob: false };
            }

            const { locale } = context;

            return {
                shouldDisplayJob: true,
                headerText: i18n.t('jobs_tbd.store_builder.header_text', { $scope: locale }),
                jobPages: [
                    {
                        title: i18n.t('jobs_tbd.store_builder.title', { $scope: locale }),
                        subtitle: i18n.t('jobs_tbd.store_builder.subtitle', { $scope: locale }),
                        ctaText: i18n.t('jobs_tbd.store_builder.cta', { $scope: locale }),
                        iconUrl: storeBuilderIconUrl,
                    },
                ],
                clickAction: {
                    type: 'link',
                    href: storeBuilderUrl,
                },
                dismissInfo: {
                    isDismissible: true,
                },
            };
        } catch (error: any) {
            logger.error(error, { description: 'Error fetching number of unread messages' });

            return {
                shouldDisplayJob: false,
            };
        }
    },
};
